import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface BankObject {
  id: number;
  titleEn: string;
  titleAr: string;
  email: string;
  name: string;
}

export interface BanksListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  banks: Array<BankObject>;
  errors: unknown;
}

@Module
export default class BanksModule extends VuexModule implements BanksListInfo {
  banks = [] as Array<BankObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get banks list
   * @returns Array<BankObject>
   */
  get banksList(): Array<BankObject> {
    return this.banks;
  }

  /**
   * Get total items
   * @returns number
   */
  get banksListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_BANKS](data) {
    this.banks = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_BANK_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_BANKS_LIST]() {
    this.banks = [] as Array<BankObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_BANKS_STORE]() {
    this.context.commit(Mutations.RESET_BANKS_LIST);
  }

  @Action
  [Actions.CREATE_BANK](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/official-appraisal/banks', data)
      .then(() => {
        this.context.commit(Mutations.RESET_BANKS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_BANK](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/official-appraisal/banks', id)
      .then(() => {
        this.context.commit(Mutations.RESET_BANKS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_BANK]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/official-appraisal/banks', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_BANKS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_BANK_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_BANK_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_BANK](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/official-appraisal/banks', id);
  }

  @Action
  [Actions.GET_BANKS](options: { limit?: number } = { limit: 10 }) {
    ApiService.setAuthorizationHeader();
    const params = { page: this.currentPage, limit: options.limit };
    return ApiService.query('/official-appraisal/banks', { params })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_BANKS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
}
